import { config, dom, library } from "@fortawesome/fontawesome-svg-core";
import * as faBrands from "@fortawesome/free-brands-svg-icons";
import * as faRegular from "@fortawesome/pro-regular-svg-icons";
import * as faSolid from "@fortawesome/pro-solid-svg-icons";
import * as faThin from "@fortawesome/pro-thin-svg-icons";

// Font Awesome would otherwise inject its CSS as a <style> element that it
// gives us no way to put a CSP nonce on. Must be set before any icon is
// rendered. The same stylesheet is imported from main.css instead, so it is
// served from our own origin.
config.autoAddCss = false;

// All the icons we want to use.
library.add(
  faBrands.faCcMastercard,
  faBrands.faCcVisa,
  faBrands.faChrome,
  faBrands.faEdge,
  faBrands.faFirefox,
  faBrands.faGithub,
  faBrands.faGoogle,
  faBrands.faLinkedin,
  faBrands.faMicrosoft,
  faBrands.faYoutube,
  faBrands.faOpenai,
  faBrands.faClaude,
  faRegular.faAddressCard,
  faRegular.faAngleLeft,
  faRegular.faAngleRight,
  faRegular.faAnglesLeft,
  faRegular.faAnglesRight,
  faRegular.faAnglesUpDown,
  faRegular.faArrowDownToLine,
  faRegular.faArrowLeftArrowRight,
  faRegular.faArrowLeftToBracket,
  faRegular.faArrowPointer,
  faRegular.faArrowRight,
  faRegular.faArrowRightFromBracket,
  faRegular.faArrowTrendUp,
  faRegular.faArrowUTurnDownLeft,
  faRegular.faArrowUpFromLine,
  faRegular.faArrowUpRightFromSquare,
  faRegular.faBan,
  faRegular.faBars,
  faRegular.faBasketShopping,
  faRegular.faBell,
  faRegular.faBolt,
  faRegular.faBook,
  faRegular.faBox,
  faRegular.faBoxArchive,
  faRegular.faBuildingColumns,
  faRegular.faBuildings,
  faRegular.faCalculatorSimple,
  faRegular.faCalendar,
  faRegular.faCalendarCheck,
  faRegular.faCalendarStar,
  faRegular.faChartColumn,
  faRegular.faChartLine,
  faRegular.faChartUser,
  faRegular.faCheck,
  faRegular.faCheckCircle,
  faRegular.faChevronDown,
  faRegular.faChevronLeft,
  faRegular.faChevronRight,
  faRegular.faChevronUp,
  faRegular.faCircle,
  faRegular.faCircleCheck,
  faRegular.faCircleDot,
  faRegular.faCircleExclamation,
  faRegular.faCircleInfo,
  faRegular.faCircleMinus,
  faRegular.faCirclePlay,
  faRegular.faCirclePlus,
  faRegular.faCircleQuestion,
  faRegular.faCircleUp,
  faRegular.faCircleUser,
  faRegular.faCircleXmark,
  faRegular.faClock,
  faRegular.faClone,
  faRegular.faCloudArrowUp,
  faRegular.faComment,
  faRegular.faCreditCard,
  faRegular.faCrystalBall,
  faRegular.faCube,
  faRegular.faDatabase,
  faRegular.faDisplayCode,
  faRegular.faDownload,
  faRegular.faEdit,
  faRegular.faEllipsis,
  faRegular.faEllipsisVertical,
  faRegular.faEnvelope,
  faRegular.faEnvelopeDot,
  faRegular.faEnvelopeOpen,
  faRegular.faEnvelopeOpenText,
  faRegular.faExternalLink,
  faRegular.faEye,
  faRegular.faFileCsv,
  faRegular.faFileExport,
  faRegular.faFileLines,
  faRegular.faFileSignature,
  faRegular.faFilePdf,
  faRegular.faFileZip,
  faRegular.faFilterList,
  faRegular.faFlask,
  faRegular.faGear,
  faRegular.faGlobePointer,
  faRegular.faGift,
  faRegular.faHandshake,
  faRegular.faHourglassHalf,
  faRegular.faInbox,
  faRegular.faKey,
  faRegular.faLaptopMobile,
  faRegular.faLayerGroup,
  faRegular.faLink,
  faRegular.faLinkSlash,
  faRegular.faList,
  faRegular.faLock,
  faRegular.faLockOpen,
  faRegular.faMagnifyingGlass,
  faRegular.faMagnifyingGlassChart,
  faRegular.faMessages,
  faRegular.faMonitorWaveform,
  faRegular.faNotEqual,
  faRegular.faPause,
  faRegular.faPen,
  faRegular.faPeopleGroup,
  faRegular.faPlugCircleExclamation,
  faRegular.faPlus,
  faRegular.faPuzzlePiece,
  faRegular.faQrcode,
  faRegular.faReceipt,
  faRegular.faRemove,
  faRegular.faRobot,
  faRegular.faRotate,
  faRegular.faRotateLeft,
  faRegular.faRotateRight,
  faRegular.faRocketLaunch,
  faRegular.faScroll,
  faRegular.faShelves,
  faRegular.faShieldUser,
  faRegular.faShield,
  faRegular.faSignsPost,
  faRegular.faSparkles,
  faRegular.faSpinnerThird,
  faRegular.faSquare,
  faRegular.faSquareCheck,
  faRegular.faSquareXmark,
  faRegular.faStore,
  faRegular.faSwatchbook,
  faRegular.faTable,
  faRegular.faThumbTack,
  faRegular.faTimeline,
  faRegular.faTrashCan,
  faRegular.faTrainTunnel,
  faRegular.faTriangleExclamation,
  faRegular.faUser,
  faRegular.faUserCowboy,
  faRegular.faUserHelmetSafety,
  faRegular.faUserPlus,
  faRegular.faUsers,
  faRegular.faWallet,
  faRegular.faWrench,
  faRegular.faXmark,
  faSolid.faArrowTrendUp,
  faSolid.faBadgeCheck,
  faSolid.faCaretDown,
  faSolid.faCaretUp,
  faSolid.faSort,
  faSolid.faTableColumns,
  faSolid.faTableRows,
  faSolid.faCircle,
  faSolid.faCircle1,
  faSolid.faCircle2,
  faSolid.faCircle3,
  faSolid.faCircleCheck,
  faSolid.faCircleExclamation,
  faSolid.faCirclePause,
  faSolid.faCirclePlay,
  faSolid.faCircleX,
  faSolid.faClockRotateLeft,
  faSolid.faLock,
  faSolid.faTriangleExclamation,
  faSolid.faWavePulse,
  faSolid.faUser,
  faSolid.faWallet,
  faThin.faWavePulse,
);

// Replace any existing <i> tags with <svg> and set up a MutationObserver to
// continue doing this as the DOM changes.
dom.watch();
